















/** @format */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// @ts-ignore hack
import EchartOption from '@root/common/const/e-chart-options';

@Component({
  components: {}
})
export default class IncomeStatistics extends Vue {
  options: EchartOption = new EchartOption();
  isData: boolean = true;

  xAxisData: string[] = [];

  @Prop({ default: () => [] })
  data: any;

  @Watch('data')
  onDataChange() {
    this.$nextTick(() => {
      this.refreshChart();
    });
  }

  get title() {
    return {
      show: false
    };
  }

  get toolTip() {
    return {
      show: true,
      trigger: 'axis',
      axisPointer: {
        type: 'line'
      },
      hideDelay: 1000,
      formatter: function(params: any[]) {
        let result = params[0].seriesName + '</br>';
        params.forEach(function(item) {
          result += item.marker + ' ' + item.name + ' : ' + item.value + 'h</br>';
        });
        return result;
      }
    };
  }

  get grid() {
    return {
      top: '8%',
      left: '5%',
      right: '5%',
      bottom: '5%',
      containLabel: true
    };
  }

  get legend() {
    return {
      show: false
    };
  }

  get xAxis() {
    return {
      type: 'category',
      boundaryGap: true,
      axisLabel: {
        color: '#000'
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      data: this.data.map((i: { describe: any }) => i.describe)
    };
  }

  get yAxis() {
    return [
      {
        type: 'value',
        axisLabel: {
          show: true,
          color: '#000'
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#ccc',
            type: 'dashed'
          }
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      }
    ];
  }

  get series() {
    return [
      {
        name: '平均停车时长',
        type: 'bar',
        barMaxWidth: 60,
        itemStyle: {
          color: '#1890ff'
        },
        label: {
          show: true,
          position: 'outside',
          color: '#000',
          formatter: '{c}h'
        },
        data: this.data.map((i: { value: any }) => i.value)
      }
    ];
  }

  refreshChart() {
    const options: EchartOption = new EchartOption();
    options.setLegend(this.legend);
    options.setGrid(this.grid);
    options.setXAxis(this.xAxis, true);
    options.setYAxis(this.yAxis, true);
    options.setTitle(this.title);
    options.setSeries(this.series);
    options.setTooltip(this.toolTip);
    this.options = options;
  }

  mounted() {
    this.refreshChart();
  }
}
